namespace Queries {
    interface IPrinterQueryFilter
        extends IQueryFilter {

    }

    export class PrinterQuery
        implements ITQueryInfo<Indexes.Printer, Entities.Printer, IPrinterQueryFilter, Entities.Printer> {
        
        private _repository: RavenDbClient;

        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }

        async execute(context: ITQueryRequestContext<Indexes.Printer, Entities.Printer>) {
            const { results: results, stats: stats } = await this._repository.queryDocuments<Entities.Printer>("printers", "", {}, context.from, context.limit)

            return {
                docs: results,
                totalResults: stats.totalResults
            }
        }

        // async execute(context: ITQueryRequestContext<Indexes.Printer, Entities.Printer>) {

        //     let query = this._query;
        //     if (context.filter.input != null)
        //         query = query.whereContainsAll("byQuery", context.filter.input.split(" ").filter(Boolean));

        //     var result  = await query
        //         .orderBy(context.orderBy ?? "byName")
        //         .skip(context.from)
        //         .limit(context.limit)
        //         .toArray();

        //     return {
        //         docs: result.docs,
        //         totalResults: result.totalResults
        //     }
        // }
        
    }
}